import Fuse from 'fuse.js'

export function changeSearchValue(query) {
    return function (dispatch) {
        dispatch({
            type: 'CHANGE_SEARCH_VALUE',
            payload: query,
        })
    }
}

export function autoCompleteSearch(query) {
    return doSearch(query, 'AUTOCOMPLETE_SEARCH')
}

export function pageSearch(query) {
    return doSearch(query, 'PAGE_SEARCH')
}

function doSearch(query, action) {
    return (dispatch, getState) => {
        dispatch({ type: action, payload: query })
        const products = getState().products.products

        var options = {
            shouldSort: true,
            includeScore: true,
            threshold: 0.2,
            location: 0,
            tokenize: true,
            distance: 100,
            includeMatches: true,
            maxPatternLength: 32,
            minMatchCharLength: 1,
            keys: ['title', 'description', 'vendor'],
        }
        var fuse = new Fuse(products, options)
        var result = fuse.search(query)

        let resultObjects = result.map((r) => r.item)
        dispatch({
            type: `PRODUCT_${action}_SUCCESS`,
            payload: {
                products: [...resultObjects],
            },
        })

        const suppliers = getState().products.suppliers
        options.keys = ['name', 'description']
        var fuse = new Fuse(suppliers, options)
        var result = fuse.search(query)

        resultObjects = result.map((r) => r.item)
        dispatch({
            type: `SUPPLIER_${action}_SUCCESS`,
            payload: {
                suppliers: [...resultObjects],
            },
        })
    }
}
